<template>
  <el-table-column
    prop="gross_price"
    label="Bruttó"
    show-overflow-tooltip
    align="right"
  >
    <template slot-scope="scope">
      {{ scope.row.gross_price | currency }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'gross_price',
};
</script>
